import { ColumnName, QueryColumn } from 'mapistry-shared';
import { useEffect, useMemo } from 'react';
import { useFormState } from 'react-final-form';
import { useSingleQueryStep } from '../../contexts/SingleQueryStepContext';

function doColumnsUseIncompleteData(
  columnNames: ColumnName[],
  availableColumns: QueryColumn[],
): boolean {
  const incompleteColumnNames = new Set(
    availableColumns.filter((c) => c.isIncompleteData).map((c) => c.columnName),
  );
  if (!incompleteColumnNames.size) return false;
  return columnNames.some((columnName) =>
    incompleteColumnNames.has(columnName),
  );
}

type IncompleteDataFormSpyProps<FormValues> = {
  getColumnNamesInUse: (values: FormValues) => ColumnName[];
};

export function IncompleteDataFormSpy<FormValues>({
  getColumnNamesInUse,
}: IncompleteDataFormSpyProps<FormValues>) {
  const { availableColumns, setIsUsingIncompleteData } = useSingleQueryStep();
  const { values } = useFormState<FormValues>({
    subscription: { values: true },
  });

  const isUsingIncompleteData = useMemo(
    () =>
      doColumnsUseIncompleteData(getColumnNamesInUse(values), availableColumns),
    [availableColumns, getColumnNamesInUse, values],
  );

  useEffect(() => {
    setIsUsingIncompleteData(isUsingIncompleteData);
  }, [isUsingIncompleteData, setIsUsingIncompleteData]);

  useEffect(
    () => () => setIsUsingIncompleteData(false),
    [setIsUsingIncompleteData],
  );

  return null;
}
